import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractContentComponent } from '../abstract-content.component';
import { Context } from '@service/context.service';
import { TranslateDirective } from '@ngx-translate/core';

import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardModule, TranslateDirective],
})
export class DashboardComponent extends AbstractContentComponent {
  constructor() {
    super(Context.Global);
    this.setBreadcrumbs([{ label: 'MENU.DASHBOARD' }]);
  }

  hasOnlyUserRole(): boolean {
    return this.authorizationService.hasOnlyUserRole();
  }
}
